import { gql } from '@apollo/client';

export const CREATE_GROUP = gql`
  mutation GROUP_SERVICE_createEStoreGroup($inputGroup: InputGroup) {
    createEStoreGroup(group: $inputGroup) {
      id
      name
      agentOfRecord {
        id
        name
        npn
        type
        email
      }
      assigned {
        id
        name
        npn
        type
      }
      contactInfo {
        firstName
        lastName
        primaryEmail
        title
        primaryPhone
        primaryAddress {
          city
          street
          street2
          zip
          state
          county
        }
      }
      notes
    }
  }
`;

export const UPDATE_GROUP = gql`
  mutation GROUP_SERVICE_updateGroup(
    $inputGroup: InputGroup
    $sponsorId: ID!
    $groupId: ID!
    $cartId: ID!
    $eStore: Boolean = true
    $isEnrollNow: Boolean = false
  ) {
    updateGroup(group: $inputGroup, eStore: $eStore) {
      id
      name
      lastUpdateTime
      agentOfRecord {
        id
        name
        npn
        type
        email
      }
      assigned {
        id
        name
        npn
        type
      }
      contactInfo {
        firstName
        lastName
        primaryEmail
        title
        primaryPhone
        primaryAddress {
          city
          street
          street2
          zip
          state
          county
        }
      }
      notes
    }
    contactMe(sponsorId: $sponsorId, groupId: $groupId, cartId: $cartId, isEnrollNow: $isEnrollNow)
  }
`;

export const GROUP_BY_ID = gql`
  query GROUP_SERVICE_groupById($id: ID!) {
    groupById(id: $id) {
      id
      name
      source
      agentOfRecord {
        id
        name
        npn
        type
        email
      }
      assigned {
        id
        name
        type
        npn
      }
      contactInfo {
        firstName
        lastName
        primaryEmail
        title
        primaryPhone
        primaryAddress {
          city
          street
          street2
          zip
          state
          county
        }
      }
      notes
    }
  }
`;
